import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertyFaq, PropertyFaqSplitted } from '@shared-ui/lodging-property-details';
import { adaptSearchCriteria } from 'src/common/stores/adapters/bex-api/common/search-criteria-adapter';
import { usePlatformContext } from 'src/common/stores/contexts/platformContext';
import { useSearchCriteriaContext } from 'src/common/stores/contexts';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'components/common/lazy/simple-lazy-load-wrapper';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const PropertyFaqWrapper = React.memo(({
  inputs
}) => {
  const context = usePlatformContext();
  const searchCriteria = useSearchCriteriaContext();
  const propertySearchCriteria = adaptSearchCriteria(context, searchCriteria);
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  return React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(ErrorBoundary, {
    label: "hotel.property.faq"
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(EGDSSpacing, {
    margin: {
      blockstart: 'six'
    }
  }, React.createElement("div", null, React.createElement(PropertyFaq, {
    inputs: Object.assign(Object.assign({}, inputs), {
      searchCriteria: propertySearchCriteria
    }),
    skipSsr: cSRPropertyDetailsQuery
  })))))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(ErrorBoundary, {
    label: "hotel.property.faq"
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(EGDSSpacing, {
    margin: {
      blockstart: 'six'
    }
  }, React.createElement("div", null, React.createElement(PropertyFaqSplitted, {
    inputs: Object.assign(Object.assign({}, inputs), {
      searchCriteria: propertySearchCriteria
    }),
    skipSsr: cSRPropertyDetailsQuery
  })))))));
});
export const SharedUiPropertyFaqWrapper = withSharedUiPropertyDetails(PropertyFaqWrapper);
PropertyFaqWrapper.displayName = 'SharedUiPropertyFaqWrapper';